import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeyatYoluContext } from "../../App";
import api from "../../services/api";
import "./styles/PaymentNotification.css";

function PaymentNotification() {
  const { user } = useContext(HeyatYoluContext);
  const [pendingProfiles, setPendingProfiles] = useState([]);
  const [showNotification, setShowNotification] = useState(true);

  useEffect(() => {
    if (user) {
      api.get("/memorialprofile/pending-payments")
        .then(res => setPendingProfiles(res.data))
        .catch(console.error);
    }
  }, [user]);

  if (!user || pendingProfiles.length === 0 || !showNotification) {
    return null;
  }

  return (
    <div className="pn-alert">
      <div className="pn-content">
        <div className="pn-icon">⚠️</div>
        <div className="pn-text">
          <h3>Diqqət! Ödəniş gözləyən profil var</h3>
          <p>
            Sizin <strong>{pendingProfiles.length}</strong> ədəd paylaşımınızın
            ödənişi tamamlanmayıb. Profilinizin aktivləşməsi üçün ödənişi tamamlayın.
          </p>
          <div className="pn-actions">
            <Link to="/kabinetim" className="pn-btn-primary">
              Kabinetimə get
            </Link>
            <button
              onClick={() => setShowNotification(false)}
              className="pn-btn-secondary"
            >
              Sonra xatırlat
            </button>
          </div>
        </div>
        <button
          className="pn-close"
          onClick={() => setShowNotification(false)}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default PaymentNotification;